// Types
import { TrackingEventsEnum, TrackingLinkEventReturnType } from '@openbank/ziniaweb-ui-core-models';
import { TrackBuilderType } from 'types/track-builder.type';
import { HeaderLayoutTrackingHandlersReturnType } from './types/header-layout.handlers.type';

const trackClickBack = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'return',
    format: 'arrow',
    component: 'header',
    element: 'arrow',
    eventAction: 'clickArrow',
    eventLabel: 'returnArrow',
  },
  type: TrackingEventsEnum.LINK,
});
const HeaderLayoutTrackingHandlers = (
  track: TrackBuilderType
): HeaderLayoutTrackingHandlersReturnType => ({
  handleTrackClickBack: () => {
    track(trackClickBack());
  },
});

export { HeaderLayoutTrackingHandlers };
